module.exports = __webpack_public_path__ + "static/media/81Jm29eV+SL._AC_UX679_.6e2b98cb.jpg";